import FilePreview from 'app/modules/filePreview/views/FilePreview';

const FilePreviewPage = () => <FilePreview />;

export default FilePreviewPage;
